export default "__VITE_ASSET__BNBQYNry__"